

export const validatePassword = (password) => {
  const validated = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
  return validated.test(password);

}

export const validateEmail = (email) => {
  const validatedEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return validatedEmail.test(email);
}

export const validatePhone = (phone) =>{
  const validatedPhone = /^\d{0,10}$/;
  return validatedPhone.test(phone);
}